import { css } from "styled-components";

const gradientBackground = css`
  background: ${props => props.theme.background.default};
  background: linear-gradient(
    0deg,
    ${props => props.theme.background.default} 0%,
    rgba(255, 255, 255, 1) 100%
  );
  background-repeat: no-repeat;
  background-attachment: fixed;
`;

export default gradientBackground;
